// Contenido del candidato propio (Federico Chouhy).
// Vaciado tras auditoría: los puntos de estrategia y eventos eran datos
// hardcodeados/ficticios. Los componentes muestran su estado vacío hasta que
// se carguen inputs editoriales reales del equipo de campaña.

export const strategyPoints = [];

export const upcomingEvents = [];
